import { useState, useEffect } from 'react';
import { httpClient } from '../common/httpclient';

export const useCompanyLogo = () => {
  const [companyLogo, setCompanyLogo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCompanyLogo = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await httpClient.get('/enterprise/cfg?name=sidebar_icon&category=general');
      
      if (response.status === 200 && response.data && response.data.value) {
        setCompanyLogo(response.data.value);
        return response.data.value;
      } else {
        // Se não há logo, retorna null
        setCompanyLogo(null);
        return null;
      }
    } catch (err) {
      console.error('Erro ao buscar logo da empresa:', err);
      setError(err);
      setCompanyLogo(null);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyLogo();
  }, []);

  return {
    companyLogo,
    isLoading,
    error,
    refetch: fetchCompanyLogo
  };
};
